import SvgCustoms from "../../../../components/main/wrappers/svg-customs/SvgCustoms";

import { ReactComponent as Church_2_1 } from "../../../../static/images/contents/zone-4/icons/2/church_1.svg";
import { ReactComponent as Church_2_2 } from "../../../../static/images/contents/zone-4/icons/2/church_2.svg";
import { ReactComponent as Church_2_3 } from "../../../../static/images/contents/zone-4/icons/2/church_3.svg";
import { ReactComponent as Church_2_4 } from "../../../../static/images/contents/zone-4/icons/2/church_4.svg";
import { ReactComponent as Church_2_5 } from "../../../../static/images/contents/zone-4/icons/2/church_5.svg";
import { ReactComponent as Church_2_6 } from "../../../../static/images/contents/zone-4/icons/2/church_6.svg";
import { ReactComponent as Church_2_7 } from "../../../../static/images/contents/zone-4/icons/2/church_7.svg";
import { ReactComponent as School_2_1 } from "../../../../static/images/contents/zone-4/icons/2/school_1.svg";
import { ReactComponent as School_2_2 } from "../../../../static/images/contents/zone-4/icons/2/school_2.svg";
import { ReactComponent as School_2_3 } from "../../../../static/images/contents/zone-4/icons/2/school_3.svg";
import { ReactComponent as School_2_4 } from "../../../../static/images/contents/zone-4/icons/2/school_4.svg";
import { ReactComponent as Shopping_2_1 } from "../../../../static/images/contents/zone-4/icons/2/shopping_1.svg";
import { ReactComponent as Hospital_2_1 } from "../../../../static/images/contents/zone-4/icons/2/hospital_1.svg";

import { ReactComponent as Church_33_1 } from "../../../../static/images/contents/zone-4/icons/33/church_1.svg";
import { ReactComponent as Church_33_2 } from "../../../../static/images/contents/zone-4/icons/33/church_2.svg";
import { ReactComponent as Church_33_3 } from "../../../../static/images/contents/zone-4/icons/33/church_3.svg";
import { ReactComponent as Church_33_4 } from "../../../../static/images/contents/zone-4/icons/33/church_4.svg";
import { ReactComponent as School_33_1 } from "../../../../static/images/contents/zone-4/icons/33/school_1.svg";
import { ReactComponent as School_33_2 } from "../../../../static/images/contents/zone-4/icons/33/school_2.svg";
import { ReactComponent as School_33_3 } from "../../../../static/images/contents/zone-4/icons/33/school_3.svg";
import { ReactComponent as School_33_4 } from "../../../../static/images/contents/zone-4/icons/33/school_4.svg";
import { ReactComponent as Shopping_33_1 } from "../../../../static/images/contents/zone-4/icons/33/shopping_1.svg";
import { ReactComponent as Hospital_33_1 } from "../../../../static/images/contents/zone-4/icons/33/hospital_1.svg";

import { ReactComponent as Church_61_1 } from "../../../../static/images/contents/zone-4/icons/61/church_1.svg";
import { ReactComponent as Church_61_2 } from "../../../../static/images/contents/zone-4/icons/61/church_2.svg";
import { ReactComponent as Church_61_3 } from "../../../../static/images/contents/zone-4/icons/61/church_3.svg";
import { ReactComponent as Church_61_4 } from "../../../../static/images/contents/zone-4/icons/61/church_4.svg";
import { ReactComponent as Church_61_5 } from "../../../../static/images/contents/zone-4/icons/61/church_5.svg";
import { ReactComponent as Church_61_6 } from "../../../../static/images/contents/zone-4/icons/61/church_6.svg";
import { ReactComponent as School_61_1 } from "../../../../static/images/contents/zone-4/icons/61/school_1.svg";
import { ReactComponent as School_61_2 } from "../../../../static/images/contents/zone-4/icons/61/school_2.svg";
import { ReactComponent as School_61_3 } from "../../../../static/images/contents/zone-4/icons/61/school_3.svg";
import { ReactComponent as School_61_4 } from "../../../../static/images/contents/zone-4/icons/61/school_4.svg";
import { ReactComponent as Shopping_61_1 } from "../../../../static/images/contents/zone-4/icons/61/shopping_1.svg";
import { ReactComponent as Hospital_61_1 } from "../../../../static/images/contents/zone-4/icons/61/hospital_1.svg";

import { ReactComponent as Church_91_1 } from "../../../../static/images/contents/zone-4/icons/91/church_1.svg";
import { ReactComponent as Church_91_2 } from "../../../../static/images/contents/zone-4/icons/91/church_2.svg";
import { ReactComponent as Church_91_3 } from "../../../../static/images/contents/zone-4/icons/91/church_3.svg";
import { ReactComponent as School_91_1 } from "../../../../static/images/contents/zone-4/icons/91/school_1.svg";
import { ReactComponent as School_91_2 } from "../../../../static/images/contents/zone-4/icons/91/school_2.svg";
import { ReactComponent as Shopping_91_1 } from "../../../../static/images/contents/zone-4/icons/91/shopping_1.svg";

export const zone4_landmarks = [
    {
        index: 2,
        default: true,
        wrapper: (
            <>
                <SvgCustoms
                    customs={[
                        {
                            Element: Church_2_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_2_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_2_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_2_4,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_2_5,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_2_6,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_2_7,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_2_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_2_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_2_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_2_4,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Shopping_2_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Hospital_2_1,
                            className: "landmark",
                            onClick: null,
                        },
                    ]}
                />
            </>
        ),
    },
    {
        index: 31,
        default: true,
        wrapper: (
            <>
                <SvgCustoms
                    customs={[
                        {
                            Element: Church_33_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_33_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_33_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_33_4,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_33_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_33_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_33_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_33_4,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Shopping_33_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Hospital_33_1,
                            className: "landmark",
                            onClick: null,
                        },
                    ]}
                />
            </>
        ),
    },
    {
        index: 61,
        default: true,
        wrapper: (
            <>
                <SvgCustoms
                    customs={[
                        {
                            Element: Church_61_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_61_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_61_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_61_4,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_61_5,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_61_6,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_61_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_61_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_61_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_61_4,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Shopping_61_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Hospital_61_1,
                            className: "landmark",
                            onClick: null,
                        },
                    ]}
                />
            </>
        ),
    },
    {
        index: 93,
        default: true,
        wrapper: (
            <>
                <SvgCustoms
                    customs={[
                        {
                            Element: Church_91_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_91_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_91_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_91_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_91_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Shopping_91_1,
                            className: "landmark",
                            onClick: null,
                        },
                    ]}
                />
            </>
        ),
    },
];
